module.exports = __webpack_public_path__ + "img/playVideo_icon.bb6978b2.png";